import React from 'react';
import Country from './Country';
import ContentView from '../../Layouts/ContentView';
const index = () => {
    return (
        <ContentView>
            <Country />
        </ContentView>
    );
};
export default index;
